import { render, staticRenderFns } from "./bot-msg.vue?vue&type=template&id=7724ac6a&scoped=true&"
import script from "./bot-msg.vue?vue&type=script&lang=js&"
export * from "./bot-msg.vue?vue&type=script&lang=js&"
import style0 from "./bot-msg.vue?vue&type=style&index=0&id=7724ac6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724ac6a",
  null
  
)

export default component.exports